import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/legal/LegalPage";

export const Route = createFileRoute("/terminos")({
  component: TermsRoute,
  head: () => ({
    meta: [
      { title: "Términos y condiciones — Sift Trip" },
      { name: "description", content: "Términos y condiciones de uso de SiftTrip." },
    ],
  }),
});

function TermsRoute() {
  return (
    <LegalPage title="Terminos y condiciones" eyebrow="Condiciones de uso">
      <LegalSection title="1. Identidad y estado actual">
        <p>
          SiftTrip es una plataforma digital de descubrimiento y comparacion de
          experiencias de viaje. La razon social, domicilio, datos fiscales y
          demas informacion societaria se encuentran en proceso de constitucion
          y seran actualizados antes de iniciar operaciones de cobro directo o
          reservas propias.
        </p>
        <p>
          Mientras esa informacion se actualiza, las comunicaciones oficiales se
          haran a traves de los canales visibles en la plataforma y las redes
          sociales oficiales de SiftTrip.
        </p>
      </LegalSection>

      <LegalSection title="2. Que hace SiftTrip">
        <p>
          SiftTrip ayuda a buscar, comparar y organizar informacion sobre tours,
          actividades, excursiones y servicios relacionados con viajes. Salvo
          que se indique expresamente lo contrario, SiftTrip no opera, presta,
          vende, cobra ni ejecuta directamente las experiencias listadas.
        </p>
        <p>
          Hoy SiftTrip no procesa pagos propios ni almacena datos de tarjetas, y
          no confirma reservas propias: la reserva se completa y se confirma en
          el sitio del proveedor externo (por ejemplo Viator o GuruWalk).
        </p>
      </LegalSection>

      <LegalSection title="3. Proveedores externos">
        <p>
          Muchas experiencias son ofrecidas por proveedores externos, plataformas
          afiliadas o marketplaces de terceros, como Viator, GuruWalk u otros
          socios futuros. Cuando el usuario hace clic para reservar o continuar
          en un proveedor externo, la reserva, disponibilidad, precio final,
          cancelacion, reembolso, seguridad, impuestos y ejecucion del servicio
          se rigen por los terminos de ese proveedor.
        </p>
      </LegalSection>

      <LegalSection title="4. Afiliados y comisiones">
        <p>
          SiftTrip puede recibir una comision, fee de afiliado u otra
          compensacion cuando un usuario reserva a traves de determinados
          enlaces. Este disclosure tambien esta explicado en la pagina de{" "}
          <Link to="/afiliados" className="font-semibold text-[#E8194B]">
            afiliados
          </Link>
          .
        </p>
        <p>
          La existencia de una comision no debe presentarse como garantia de
          calidad ni como precio mas bajo. El precio final debe verificarse
          siempre en la pagina del proveedor antes de reservar.
        </p>
      </LegalSection>

      <LegalSection title="5. Informacion, precios y disponibilidad">
        <LegalList
          items={[
            "La disponibilidad puede cambiar sin aviso.",
            "Los precios, monedas, impuestos y cargos pueden variar segun proveedor, fecha, viajeros y condiciones locales.",
            "Cuando SiftTrip muestra un precio convertido a otra moneda, esa conversion usa una tasa de referencia y es solo informativa; el precio y la moneda vinculantes son los que confirma el proveedor al momento de reservar.",
            "SiftTrip puede mostrar precios estimados o informacion resumida; el precio vinculante es el que se confirma en el checkout del proveedor o en la oferta final aplicable.",
            "Las experiencias de aporte voluntario o propina libre no son experiencias gratuitas garantizadas; el usuario debe revisar las reglas del proveedor.",
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Recomendaciones e inteligencia artificial">
        <p>
          SiftTrip puede usar sistemas automaticos o de inteligencia artificial
          para organizar resultados, resumir experiencias o sugerir opciones. La
          informacion puede ser incompleta, desactualizada o contener errores. El
          usuario debe verificar horarios, ubicacion, restricciones, clima,
          visas, requisitos de salud, accesibilidad, seguridad y condiciones del
          proveedor antes de viajar o reservar.
        </p>
      </LegalSection>

      <LegalSection title="7. Reservas, cancelaciones y reembolsos">
        <p>
          Si la reserva se completa en un proveedor externo, las cancelaciones,
          reembolsos, cambios, no-shows y reclamaciones operativas se tramitan
          con ese proveedor, bajo sus politicas. Si en el futuro SiftTrip cobra
          directamente por una experiencia, se publicaran terminos especificos
          de compra, cancelacion, reembolso y soporte antes del pago.
        </p>
      </LegalSection>

      <LegalSection title="8. Consumidor colombiano">
        <p>
          Cuando aplique la ley colombiana, SiftTrip respetara los derechos del
          consumidor previstos por el Estatuto del Consumidor y las normas de
          comercio electronico, incluyendo informacion clara sobre identidad del
          proveedor, precio, condiciones, canales de atencion y mecanismos de
          reclamacion. Algunas reglas, como retracto o reversion de pago, pueden
          depender de si SiftTrip actua como vendedor directo o solo como
          intermediario/comparador.
        </p>
      </LegalSection>

      <LegalSection title="9. Turismo y RNT">
        <p>
          SiftTrip no se presenta actualmente como operador turistico ni agencia
          que venda paquetes propios. Si la operacion futura requiere Registro
          Nacional de Turismo, contratos con DMCs, pagos directos o prestacion
          turistica en Colombia, SiftTrip debera actualizar estos terminos y su
          cumplimiento antes de iniciar esa actividad.
        </p>
      </LegalSection>

      <LegalSection title="10. Cuenta del usuario">
        <p>
          Si el usuario crea una cuenta (por ejemplo con Google o con un enlace
          magico por correo), es responsable de mantener el acceso a su propia
          sesion y de avisar si sospecha un uso no autorizado. La cuenta permite
          guardar preferencias, busquedas recientes, experiencias guardadas
          (wishlist) y comparaciones guardadas.
        </p>
        <p>
          Hoy no existe un flujo de autoeliminacion de cuenta dentro de la
          plataforma. El usuario puede solicitar la correccion o eliminacion de
          su cuenta y de los datos asociados escribiendo a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="11. Propiedad intelectual">
        <p>
          El nombre "SiftTrip", su logo, diseno, textos e interfaz son propiedad
          de SiftTrip o se usan bajo licencia. El usuario no puede copiar,
          reproducir, redistribuir ni crear obras derivadas de la plataforma sin
          autorizacion previa. La informacion, imagenes y descripciones de
          experiencias mostradas en SiftTrip pertenecen a sus respectivos
          proveedores (por ejemplo Viator o GuruWalk) y se muestran bajo los
          acuerdos aplicables con cada uno.
        </p>
      </LegalSection>

      <LegalSection title="12. Uso permitido">
        <LegalList
          items={[
            "No usar la plataforma para fraude, abuso, scraping no autorizado, ataques automatizados o violacion de derechos de terceros.",
            "No cargar contenido falso, ilegal, discriminatorio, difamatorio o que infrinja propiedad intelectual.",
            "No enviar spam ni usar la plataforma para comunicaciones masivas no solicitadas.",
            "No intentar eludir medidas tecnicas, rate limits, autenticacion o controles de seguridad.",
          ]}
        />
      </LegalSection>

      <LegalSection title="13. Limitacion de responsabilidad">
        <p>
          En la maxima medida permitida por la ley aplicable, SiftTrip no sera
          responsable por actos, omisiones, cambios, cancelaciones, accidentes,
          perdidas, danos, lesiones, incumplimientos o informacion provista por
          proveedores externos. Nada en estos terminos limita derechos
          irrenunciables del consumidor cuando la ley aplicable no lo permita.
        </p>
      </LegalSection>

      <LegalSection title="14. Cambios">
        <p>
          SiftTrip puede actualizar estos terminos, y puede agregar, modificar o
          retirar funciones del servicio, para reflejar cambios legales,
          operativos o de producto. La fecha de actualizacion visible en esta
          pagina indica la version vigente.
        </p>
      </LegalSection>

      <LegalSection title="15. Contacto">
        <p>
          Para preguntas sobre estos terminos, escribe a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
